export default __webpack_public_path__ + "static/media/flam@2x.6bb24034.png";